
import { useState } from 'react';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'Q. どのような業種に対応していますか？',
      answer: '運送業、配送業、物流業界全般に対応しています。大型トラック、中型トラック、軽貨物、宅配便、引越し業者など、あらゆるドライバー職種の採用をサポートいたします。'
    },
    {
      question: 'Q. 契約期間はありますか？',
      answer: '基本的には6ヶ月からの契約となります。ただし、お客様のご要望に応じて柔軟に対応いたしますので、まずはご相談ください。'
    },
    {
      question: 'Q. 地方でも対応可能ですか？',
      answer: 'はい、全国どちらでも対応可能です。オンラインでのサポートを中心に、必要に応じて現地での打ち合わせも行います。'
    },
    {
      question: 'Q. 成果が出なかった場合はどうなりますか？',
      answer: '万が一成果が出ない場合は、戦略の見直しや追加施策を無料で実施いたします。お客様の採用成功まで責任を持ってサポートします。'
    },
    {
      question: 'Q. 他社との違いは何ですか？',
      answer: '運送業界に特化した専門性と、Indeed・スタンバイ・求人ボックスでの豊富な実績が強みです。業界特有の課題を理解し、効果的な採用戦略をご提案できます。'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-6">
            <span className="text-blue-600">よくある質問</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            お客様からよくいただくご質問にお答えします
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className="border border-gray-200 rounded-lg overflow-hidden">
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full px-6 py-4 text-left bg-gray-50 hover:bg-gray-100 transition-colors duration-300 flex justify-between items-center cursor-pointer"
                >
                  <h3 className="text-lg font-semibold text-gray-800 pr-4">
                    Q. {faq.question}
                  </h3>
                  <div className="flex-shrink-0">
                    <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-blue-600 text-xl transition-transform duration-300`}></i>
                  </div>
                </button>

                {openIndex === index && (
                  <div className="px-6 py-4 bg-white border-t border-gray-200">
                    <p className="text-gray-700 leading-relaxed">
                      A. {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-16">
          <div className="bg-blue-50 rounded-xl p-8 max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-800 mb-4">
              <i className="ri-question-line text-blue-600 mr-2"></i>
              その他のご質問がございましたら
            </h3>
            <p className="text-lg text-gray-600 mb-6">
              お気軽にお問い合わせください。運送業界専門のコンサルタントが丁寧にお答えします。
            </p>
            <button className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-lg transition-colors duration-300 whitespace-nowrap cursor-pointer">
              <i className="ri-phone-line mr-2"></i>
              無料相談で質問する
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
